import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="bg-slate-50 min-h-screen" data-testid="payment-cancel-page">
      <Navbar />
      <main className="pt-32 pb-20 max-w-xl mx-auto px-4 text-center">
        <XCircle className="h-16 w-16 text-amber-500 mx-auto mb-6" />
        <h1 className="text-3xl font-heading font-bold text-slate-900">Pago cancelado</h1>
        <p className="text-slate-600 mt-3">
          No se ha realizado ningún cargo. Puedes volver a intentarlo cuando quieras.
        </p>
        <div className="mt-8 flex justify-center gap-4">
          <Button asChild className="bg-cyan-500 hover:bg-cyan-600 rounded-full px-8" data-testid="cancel-retry-btn">
            <Link to="/reservar">Volver a reservar</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full px-8">
            <Link to="/">Ir al inicio</Link>
          </Button>
        </div>
      </main>
    </div>
  );
}
